import React from "react"
import { Navigation } from "@kit/design/navigation"
import { isStaticFeatureEnabled } from "hooks/use-feature"
import { useCommandPaletteStore } from "./store"

/**
 * Nav entry point for the command palette: wires the shared palette store to
 * the design system's `Navigation.CommandTrigger`. Keeping the store wiring here
 * means the DS Navigation has no dependency on the command palette.
 */
export function CommandPaletteTrigger() {
  const setOpen = useCommandPaletteStore(state => state.setOpen)

  if (!isStaticFeatureEnabled("command_palette")) return null

  return <Navigation.CommandTrigger onClick={() => setOpen(true)} />
}
